import React from "react";
import cn from "classnames";
import css from "./Icon.module.css";

type Icon = "chevron-down" | "check-solid" | "trasn-one" | "sofa" | "printer" | "pencil";

type IconProps = {
    icon: Icon;
    className?: string;
    size?: "24px" | "32px";
};

export const Icon = ({ icon, className, size = "24px" }: IconProps) => {
    return (
        <span
            className={cn(css.main, className)}
            style={{ ["--size"]: size } as React.CSSProperties}
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                {getIconContent(icon)}
            </svg>
        </span>
    );
};

const getIconContent = (icon: Icon) => {
    switch (icon) {
        case "chevron-down":
            return (
                <path
                    d="M6 9L12 15L18 9"
                    stroke="var(--color-stroke, #111111)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            );
        case "check-solid":
            return (
                <path
                    d="M6 13.5L8.32638 16.408C9.16163 17.452 10.7664 17.3983 11.5299 16.3007L18 7"
                    stroke="var(--color-stroke, #111111)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                />
            );
        case "trasn-one":
            return (
                <path
                    d="M18 7L17.114 17.342C17.003 18.632 16.948 19.278 16.661 19.766C16.4085 20.1962 16.033 20.5409 15.583 20.756C15.072 21 14.423 21 13.128 21H10.872C9.576 21 8.928 21 8.417 20.756C7.96695 20.5409 7.59153 20.1962 7.339 19.766C7.052 19.278 6.997 18.632 6.886 17.342L6 7M4.5 6.5H9.115M9.115 6.5L9.501 3.828C9.613 3.342 10.017 3 10.481 3H13.519C13.983 3 14.386 3.342 14.499 3.828L14.885 6.5M9.115 6.5H14.885M14.885 6.5H19.5"
                    stroke="var(--color-stroke, #111111)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            );
        case "sofa":
            return (
                <path
                    d="M7.5 18V20M16.5 18V20M4.8 9.844C3.9 9.864 3 10.271 3 11V15C3 16.657 4.209 18 5.7 18H18.3C19.791 18 21 16.657 21 15V11C21 10.188 20.1 9.824 19.2 9.844M4.8 9.844C5.7 9.824 6.6 10.188 6.6 11C6.6 12.363 6.825 14 8.6 14H15.4C17.175 14 17.4 12.363 17.4 11C17.4 10.27 18.3 9.865 19.2 9.844M4.8 9.844V7C4.8 5.343 6.009 4 7.5 4H16.5C17.991 4 19.2 5.343 19.2 7V9.844"
                    stroke="var(--color-stroke, #111111)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            );
        case "printer":
            return (
                <>
                    <path
                        d="M19 10V5C19 4.73478 18.8946 4.48043 18.7071 4.29289C18.5196 4.10536 18.2652 4 18 4H6C5.73478 4 5.48043 4.10536 5.29289 4.29289C5.10536 4.48043 5 4.73478 5 5V10M20 10H4C3.73478 10 3.48043 10.1054 3.29289 10.2929C3.10536 10.4804 3 10.7348 3 11V19C3 19.2652 3.10536 19.5196 3.29289 19.7071C3.48043 19.8946 3.73478 20 4 20H20C20.2652 20 20.5196 19.8946 20.7071 19.7071C20.8946 19.5196 21 19.2652 21 19V11C21 10.7348 20.8946 10.4804 20.7071 10.2929C20.5196 10.1054 20.2652 10 20 10Z"
                        stroke="var(--color-stroke, #111111)"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                    <path
                        d="M17.5 20V17C17.5 16.7348 17.3946 16.4804 17.2071 16.2929C17.0196 16.1054 16.7652 16 16.5 16H11C10.7348 16 10.4804 16.1054 10.2929 16.2929C10.1054 16.4804 10 16.7348 10 17V20M6 13H8"
                        stroke="var(--color-stroke, #111111)"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </>
            );
        case "pencil":
            return (
                <path
                    d="M8.8 20.199C8.54654 20.4528 8.24554 20.6542 7.91421 20.7916C7.58288 20.9291 7.22771 20.9998 6.869 21H3V17.156C3 16.432 3.288 15.737 3.8 15.225M8.8 20.199L3.8 15.225M8.8 20.199L18.774 10.221M3.8 15.225L15.21 3.80196C15.4638 3.54781 15.7651 3.34618 16.0968 3.20857C16.4286 3.07097 16.7842 3.00009 17.1433 3C17.5024 2.99991 17.8581 3.0706 18.1899 3.20803C18.5217 3.34546 18.8231 3.54695 19.077 3.80096L20.203 4.92796C20.7155 5.44049 21.0035 6.13563 21.0035 6.86045C21.0035 7.58528 20.7155 8.28042 20.203 8.79296L18.774 10.221M18.774 10.221L13.783 5.22995"
                    stroke="var(--color-stroke, #111111)"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            );
        default:
            return null;
    }
};
